export default __webpack_public_path__ + "static/media/tick-mark.ceb282e6.svg";